import { PlaylistAddCheck } from '@mui/icons-material';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import UnpublishedIcon from '@mui/icons-material/Unpublished';
import { makeObservable, observable } from 'mobx';
import SituacaoConfirmacaoProcessoPautaSessao, {
    SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO
} from '../../dominio/SituacaoConfirmacaoProcessoPautaSessao';
import { Filtro } from './Filtro';

export default class FiltroInclusaoConfirmadaPauta extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';

    get label() {
        return 'Confirmação de inclusão em pauta/sessão';
    }

    getIconeFiltroRapido() {
        return <PlaylistAddCheck />;
    }

    opcoesFiltro = FiltroInclusaoConfirmadaPauta.#carregarOpcoes();

    filtroRapido = { opcoes: this.getOpcoesFiltro('valor') };

    static #carregarOpcoes() {
        return [
            {
                valor: SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO.CONFIRMADO.id,
                icone: <TaskAltIcon />
            },
            {
                valor: SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO.NAO_CONFIRMADO.id,
                icone: <UnpublishedIcon />
            }
        ];
    }

    constructor(props) {
        super(props);

        makeObservable(this, {
            filtroRapido: observable
        });
    }

    getValorOpcao(registro) {
        if (registro.confirmadaInclusaoPauta) {
            return SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO.CONFIRMADO.id;
        }

        return SITUACAO_CONFIRMACAO_PROCESSO_PAUTA_SESSAO.NAO_CONFIRMADO.id;
    }

    getDescricao(valor) {
        return SituacaoConfirmacaoProcessoPautaSessao.getDescricao(valor);
    }
}
